/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable max-len */
export const FilterPayloadConstruction = (result) => {
    const myArray = result;
    const myPayloadArray = [];
    for (const obj1 of myArray) {
        if (obj1.status == 1 && obj1.items.length !== 1) myPayloadArray.push(obj1.id);
        else if (obj1.status == -1 || (obj1.status == 1 && obj1.items.length === 1)) {
            for (const obj2 of obj1.items) {
                if (obj2.status == 1 && obj2.items && obj2.items.length !== 1) myPayloadArray.push(obj2.id);
                else if (obj2.status == -1 || (obj2.status == 1 && obj2.items.length === 1)) {
                    for (const obj3 of obj2.items) {
                        if (obj3 && obj3.status == 1 && obj3.items !== undefined && obj3.items.length !== 1) myPayloadArray.push(obj3.id);
                        else if (obj3 && obj3.status == 1) myPayloadArray.push(obj3.id);
                        else if (obj3.status == -1 || (obj3.status == 1 && obj3.items !== undefined && obj3.items.length === 1)) {
                            for (const obj4 of obj3.items) {
                                if (obj4.status == 1) myPayloadArray.push(obj4.id);
                            }
                        }
                    }
                }
            }
        }
    }
    return myPayloadArray;
};
